import { ExchangeService } from '../../exchange/exchange.service';
import { CrisprCartService } from '../../crispr/crispr-cart.service';
import { NarwhalService } from '../../narwhal.service';
import { ExchangeCartService } from '../../exchange/exchange-cart.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from '../../user.service';
import { defs } from '../../defs';
import { LoginResponseDto } from '../../api/loginResponseDto'
import { LoginMetaMaskDto } from '../../api/loginMetaMaskDto';

const jwtHelper = new JwtHelperService();

@Injectable()
export class AuthService {
	public token: string;
	private loggedIn: BehaviorSubject<boolean>;

	constructor(
		private exchangeCartService: ExchangeCartService,
		private router: Router,
		private userService: UserService,
		private crisprCartService: CrisprCartService,
		private exchangeService: ExchangeService,
		private narwhalService: NarwhalService
	) {
		this.token = localStorage.getItem(defs.authToken);
		this.loggedIn = new BehaviorSubject<boolean>(this.isLoggedIn());
	}

	getCurrentUserId(): string {
		return localStorage.getItem(defs.userId);
	}

	getTokenPayload(): any {
		const token = this.token || localStorage.getItem(defs.authToken);
		return jwtHelper.decodeToken(token);
	}

	isLoggedIn(): boolean {
		const token = this.token || localStorage.getItem(defs.authToken);
		try {
			return !jwtHelper.isTokenExpired(token);
		} catch (e) {
			return false;
		}
	}

	login(email: string, pwd: string): Observable<any> {
		return this.userService.login(email, pwd).pipe(map(this.handleLoginResponse));
	}

	loginWithMetaMask = (metamaskDto: LoginMetaMaskDto): Promise<LoginResponseDto> => {
		return this.userService
			.loginWithMetaMask(metamaskDto)
			.pipe(map(this.handleLoginResponse))
			.toPromise();
	};

	loginAfterActivation(code: string): Observable<any> {
		return this.userService.activate(code).pipe(map(this.handleLoginResponse));
	}

	private handleLoginResponse = (response: LoginResponseDto): LoginResponseDto => {
		if (response) {
			this.token = response.token;
			localStorage.setItem(defs.authToken, this.token);
			localStorage.setItem(defs.userId, this.getTokenPayload().userExtId);
			this.loggedIn.next(true);

			const redirect = localStorage.getItem(defs.previousUrl);

			if (redirect) {
				localStorage.setItem(defs.previousUrl, null);
				this.router.navigateByUrl(redirect);
			}

			return response;
		}
	};

	clearLocalStorage() {
		localStorage.removeItem(defs.userId);
		localStorage.removeItem(defs.authToken);
		localStorage.removeItem(defs.previousUrl);
		localStorage.removeItem(defs.activationToken);
		const mySwarmExchangeFilterObj = JSON.parse(localStorage.getItem(defs.mySwarmFilter));
		if (mySwarmExchangeFilterObj) {
			const { sortBy, ...rest } = mySwarmExchangeFilterObj;
			this.narwhalService.setMySwarmQueryParams({ sortBy });
		}
		const exchangeFilterObj = JSON.parse(localStorage.getItem(defs.exchangeFilter));
		if (exchangeFilterObj) {
			const { sortBy, ...rest } = exchangeFilterObj;
			this.exchangeService.setQueryParams({ sortBy });
		}
	}

	logout() {
		this.token = null;
		this.clearLocalStorage();
		this.exchangeCartService.emptyCart();
		this.crisprCartService.emptyCart();
		this.loggedIn.next(false);
	}

	isLoggedInAsObservable() {
		return this.loggedIn.asObservable();
	}
}